<script lang="ts" setup>
import { ref, watch } from 'vue'
import FormLogin from './form-login.vue'
import FormRegister from './form-register.vue'
import { ModalCollection } from '~/constants'
import { useModal } from '~/composables/common/use-modal'
import { useModalStore } from '~/stores/modal.store.ts'
import ModalAuth from '~/components/common/auth/modal-auth.vue'
import { modalList } from '~resources/popup-notification.ts'
import { notificationPopup } from '~utils/modal/notify.ts'

const { getModal, updateModal, openModal } = useModal()
const store = useModalStore()
const tabActive = ref(ModalCollection.LOGIN)
function setTabActive(tabId: ModalCollection): void {
  tabActive.value = tabId
  const currentModal = getModal(ModalCollection.LOGIN_AND_SIGN_UP)
  updateModal({
    ...currentModal,
    tabId: tabActive.value
  })
}
function handleCloseModal(): void {
  if (tabActive.value === ModalCollection.SIGN_UP) {
    openModal(ModalCollection.LOGIN_AND_SIGN_UP, ModalCollection.SIGN_UP, true)
    notificationPopup(modalList.REGISTER_AGAIN)
  }
}

watch(
  () => store.items,
  () => {
    const modal = getModal(ModalCollection.LOGIN_AND_SIGN_UP)
    if (modal.id) {
      tabActive.value = modal.tabId as ModalCollection
    }
  },
  { immediate: true }
)
</script>
<template>
  <div>
    <ModalAuth
      :modalId="ModalCollection.LOGIN_AND_SIGN_UP"
      modalPositionClass="modal-auth-dialog"
      @handleCloseModal="handleCloseModal"
    >
      <div class="auth-form">
        <ul class="auth-form__tabs">
          <li
            class="auth-form__item"
            :class="{ active: tabActive === ModalCollection.LOGIN }"
            @click="setTabActive(ModalCollection.LOGIN)"
          >
            ĐĂNG NHẬP
          </li>
          <li
            class="auth-form__item"
            :class="{ active: tabActive === ModalCollection.SIGN_UP }"
            @click="setTabActive(ModalCollection.SIGN_UP)"
          >
            ĐĂNG KÝ
          </li>
        </ul>
        <div class="auth-form__form">
          <FormLogin v-if="tabActive === ModalCollection.LOGIN" />
          <FormRegister v-else-if="tabActive === ModalCollection.SIGN_UP" />
        </div>
      </div>
    </ModalAuth>
  </div>
</template>
<style lang="scss" scoped>
@import '~scssAsset/desktop/auth/modal-auth.scss';
</style>
